import React from "react";
 
const Preferences = () => {
    return (
        <div>
            <h1>
                This is my preferenecs
            </h1>
        </div>
    );
};
 
export default Preferences;